import hash from 'object-hash'
import Vue from 'vue'
import {OK} from 'http-status-codes'
import {make} from 'vuex-pathify'
import {ptracGetEntities, ptracPost} from "src/utilities/ptracApi";
import {hydrateEdit, updateResult} from "src/utilities/vuex2";
import _ from 'lodash'

let initialState = {
  results: [],
  edit: {
    id: null,
    parentEntityId: null,
    parentEntityIdHash: null,
    byUserId: null,
    message: ''
  },
  parentEntityIdHashes: [],
  entityIdHashesAndCommentCount: {}
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.postPayload = (state) => {
  return {
    endpoint: 'comments',
    data: state.edit
  }
}
getters.message = (state) => {
  if (!state.edit.message) {
    state.edit.message = ''
  }
  return state.edit.message
}
getters.count = (state) => {
  return (entityIdHash) => {
    return state.entityIdHashesAndCommentCount[entityIdHash] || 0
  }
}

const mutations = make.mutations(state)
mutations.hydrateEdit = hydrateEdit
mutations.appendComment = (state, comment) => {
  state.results.push(comment)
}
mutations.updateComment = (state, comment) => {
  updateResult(state, comment)
}
mutations.deleteComment = (state, commentId) => {
  state.results = _.filter(state.results, (comment) => comment.id !== commentId)
}
mutations.resetMessage = (state) => {
  state.edit.message = ''
}
mutations.incrementCommentCount = (state, hash) => {
  if (!state.entityIdHashesAndCommentCount.hasOwnProperty(hash)) {
    state.entityIdHashesAndCommentCount[hash] = 0
  }
  state.entityIdHashesAndCommentCount[hash]++
}
mutations.decrementCommentCount = (state, hash) => {
  if (!state.entityIdHashesAndCommentCount.hasOwnProperty(hash)) {
    state.entityIdHashesAndCommentCount[hash] = 0
  }
  state.entityIdHashesAndCommentCount[hash]--
}
mutations.addIdHash = (state, payload) => {
  state.parentEntityIdHashes.push(payload)
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchByParentEntityId ({ state, commit, rootState }, parentEntityId) {
      const parentEntityIdHash = hash(parentEntityId)
      state.edit.parentEntityId = parentEntityId
      state.edit.parentEntityIdHash = parentEntityIdHash
      state.edit.byUserId = rootState.security.user.id

      const response = await ptracGetEntities('comments/search/findByParentEntityIdHashOrderByCreatedAtAsc?parentEntityIdHash=' + parentEntityIdHash)
      if (OK === response.status) {
        state.results = response.data
      }
      return response
    },
    async fetchCountsByParentEntityIdHash({state} ) {
      const response = await ptracPost('comments/findByParentEntityIdHashes', state.parentEntityIdHashes)
      if (OK === response.status) {
        state.entityIdHashesAndCommentCount = response.data
      }
      return response
    }
  }
}
